import React, { Component } from 'react';
import { connect } from 'dva';
import { modelUtils } from "@/utils";
import { Descriptions } from 'antd';
import { utils_tool, component_tool, framework_tool } from '@/tool';
let { Session, Storage, checkStrLength } = utils_tool;
import '@/styles/containers/workflow/procTask/index.less'

let { WizButton, WizPopover, WizDataTable, WizCollapse, WizAntdForm, WizCustomSteps, WizModal, WizRow, WizCol, WizIcon, WizCommonSteps } = component_tool;
let { WizContainer, WizReduxTemplate } = framework_tool;
import { Spin } from 'antd'
import { reduxTemplateCofig } from './config'

class AuthPerson extends WizContainer {

  componentName = 'AuthPerson';

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      personInfo: null,
      indentityTime: new Date().getTime()
    }
  }

  _componentDidMount() {
  }
  propsAndStateOnChange = {
    findIdentities: this._findIdentities.bind(this)
  }
  /**
   * 显示modal
   */
  showWizForm = () => {
    this.setState({
      showModal: true
    })

  };

  _renderFooter = () => {
    return (
      <WizRow className='form-btns col-item'>
        <WizCol span={24}>
        </WizCol>
      </WizRow>
    )
  }
  identityContent = () => {
    const { personInfoLoading } = this.props
    const { personInfo, indentityTime } = this.state
    let identity = []
    if (personInfo && personInfo['userIdentityInfoList']) {
      personInfo['userIdentityInfoList'].forEach(element => {
        identity.push(
          <>
            <Descriptions.Item label="组织："> {element['orgName']}</Descriptions.Item>
            <Descriptions.Item label="岗位："> {element['positionName']}</Descriptions.Item>
            <Descriptions.Item label="任职状态："> {element['jobState'] ? '在职' : '离职'}</Descriptions.Item>
            {/* // <WizRow className='administrationScope-row-item'>
        // <WizCol className='col-item' span={2} offset={0}>{'组织：'}</WizCol>
        // <WizCol span={6}> {element['orgName']}</WizCol>
        // <WizCol className='col-item' span={2} offset={0}>{'岗位：'}</WizCol>
        // <WizCol span={6}>{element['positionName']}</WizCol>
        // <WizCol className='col-item' span={2} offset={0}>{'任职状态：'}</WizCol>
        // <WizCol span={6}>{element['jobState']?'在职':'离职'}</WizCol>
        // </WizRow>) */}
          </>)
      });
    }
    return <div key={indentityTime}>
      <Spin tip={"加载中"} spinning={personInfoLoading}>
        <Descriptions title=""  >
          {identity}
        </Descriptions>
      </Spin>
    </div>
  }
  _render() {

    const columns = () => {
      return [{
        name: "personId",
        key: "personId",
        formItem: {
          type: "hidden",
        }
      },
      {
        title: "账户",
        name: "userName",
        dataIndex: "userName",
        tableItem: {
        },
      },
      {
        title: "姓名",
        name: "fullName",
        dataIndex: "fullName",
        tableItem: {
        },
      },
      {
        title: "证件号码",
        name: "idCard",
        dataIndex: "idCard",
        tableItem: {
        },
      },
      {
        title: "账号状态",
        name: "state",
        dataIndex: "state",
        tableItem: {
        },
        searchItem: {},
        dict: [
          { code: 1, codeName: "激活" },
          { code: 0, codeName: "禁用" }
        ]
      },
      {
        title: "姓名",
        name: "fullName",
        dataIndex: "fullName",
        searchItem: {
        },
      },
      {
        title: "手机号",
        name: "mobile",
        dataIndex: "mobile",
        tableItem: {
        },
      },

      {
        title: "操作",
        dataIndex: "action",
        name: "action",
        tableItem: {
          render: (text, record) => {
            return (
              record && record['personId'] ?
                <WizDataTable.Oper>
                  <WizPopover content={this.identityContent()} title="任职详情" trigger="click" >
                    <WizButton tooltip="查看任职" onClick={e => {

                      this.doAction({
                        path: 'personInfo/findIdentities',
                        payload: {
                          key: 'personInfo@findIdentities',
                          apiParams: {
                            personId: record['personId'],
                            state: 1
                          }
                        }
                      })

                    }}>
                      查看任职
                   </WizButton>
                  </WizPopover>
                </WizDataTable.Oper>

                : null
            )
          }
        }
      }
      ]
    }

    let templateConfig = {
      mainProps: {},
      content: {
        name: "WizTableList",
        params: {
          columns: columns(this),
          searchBarProps: {
            cols: {
              xs: 24,
              md: 12,
              xl: 8
            },
            buttonSort: [],
          },
          modalFormProps: {},
          dataTableProps: {
            rowKey: "id",
            selectType: null,
            isScroll: true,
            loading: false
          },
          commonOperate: {},

        }
      }
    };

    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig,
      procInstId: '63f261b2837071ed62a0c29d5a7c983c',
      apiDataFormat: {
      },
    })

    return (
      <div>
        <WizButton type="button" className="look-ant-btn" onClick={() => { this.showWizForm() }}>
          查看审核人群
              </WizButton>
        <WizModal
          width={900}
          visible={this.state.showModal}
          destroyOnClose={true}
          footer={null}
          onCancel={() => this.setState({ showModal: false })}
        >
          <WizReduxTemplate {..._reduxTemplateCofig} />
        </WizModal>
      </div>
    )

  }

  _findIdentities(nextProps, nextState) {
    if (nextProps.findIdentities.code == 1) {
      nextState['personInfo'] = nextProps.findIdentities.data
      nextState['indentityTime'] = new Date().getTime()
    } else {
      wizNotice.error('获取任职失败：' + nextProps.findIdentities.msg);
    }
    return true;
  }
}

const mapStateToProps = (state, ownProps) => {

  const { authPerson, personInfo } = state;
  const findIdentities = modelUtils.getModelEntity(personInfo, 'personInfo@findIdentities');
  const load = modelUtils.getLoadingState(state, 'personInfo');
  return {
    findIdentities,
    ...load
  }
  return {}
};

export default connect(mapStateToProps)(AuthPerson)
